import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import SolutionCards from './components/SolutionCards';
import IntegrationSection from './components/IntegrationSection';
import RoadmapSection from './components/RoadmapSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import SeoJsonLd from '../../components/SeoJsonLd';

const HomePage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zimmetle.com';

  return (
    <>
      <SeoJsonLd
        type="WebSite"
        data={{
          name: 'Zimmetle.com',
          url: siteUrl,
          description: 'IT envanter yönetimi ve dijital zimmet çözümleri platformu',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: `${siteUrl}/?s={search_term_string}`
            },
            'query-input': 'required name=search_term_string'
          }
        }}
      />
      
      <SeoJsonLd
        type="Organization"
        data={{
          name: 'Zimmetle.com',
          url: siteUrl,
          logo: `${siteUrl}/logo.png`,
          description: 'IT envanter yönetiminde dijital dönüşümün öncüsü',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            availableLanguage: ['tr', 'en']
          }
        }}
      />
      
      <SeoJsonLd
        type="SoftwareApplication"
        data={{
          name: 'Zimmetle.com',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'TRY'
          },
          description: 'ManageEngine ServiceDesk Plus entegrasyonu ile IT envanter yönetimi ve dijital zimmet çözümleri',
          featureList: [
            'Kullanıcı onaylı envanter güvenliği',
            'Akıllı zimmet formu oluşturucu',
            'ManageEngine ServiceDesk Plus entegrasyonu',
            'Dijital doğrulama sistemi'
          ]
        }}
      />

      <div className="min-h-screen bg-white">
        <Navbar />
        <HeroSection />
        <SolutionCards />
        <IntegrationSection />
        <RoadmapSection />
        <ContactSection />
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
